module.exports = __webpack_public_path__ + "assets/img/plan4-4.5df37bc3.png";